import Vue from 'vue';
export default {
    regionList: [],
    regionInfos: {},
    priceSet: {},
    BwsSet: [],
    LineSet: [],
    osImages: [],
    pTypeConfig: [],
    imageSet: [],
    dedicatedList: [],
    projList: [],
    snapList: [],
    snapEbsListTotal: 0,
    lessSnapNum: 0,
    clusterlist:[],
    regionMap(key) { //机房映射
        var map = {
            // "cn-beijing-6": Vue.$trans(`北京6区（VPC）`),     //北京6区
            // "cn-beijing-5": Vue.$trans(`北京5区`),
            // "cn-shanghai-2": Vue.$trans(`上海2区（VPC）`),    //上海2区
            // "cn-shanghai-3": Vue.$trans(`上海3区（VPC）`),    //上海3区
            // "cn-shanghai-7": Vue.$trans(`上海3区（Basic）`),     //上海3区(Basic)
            // 'cn-hongkong-2': Vue.$trans(`香港2区（VPC）`),    //香港2区(VPC)
            // 'cn-shanghai-1': Vue.$trans(`上海1区`),
            // 'ap-singapore-1': Vue.$trans(`新加坡1区（VPC）`), //新加坡机房
            // 'cn-hongkong-1': Vue.$trans(`香港1区`),
            // 'cn-beijing-3': Vue.$trans(`北京3区`),
            // 'cn-beijing-1': Vue.$trans(`北京1区`),
            // 'cn-beijing-1-new':Vue.$trans(`北京1区（VPC）`),
            // 'cn-guangzhou-1': Vue.$trans(`广州1区（VPC）`),
            // 'eu-east-1': Vue.$trans(`俄罗斯1区（VPC）`),
            // 'cn-wuhan-1': Vue.$trans(`武汉1区（VPC）`),
            // 'cn-taipei-1': Vue.$trans(`台北1区（VPC）`), //台北1区(VPC)
            // 'cn-beijing-fin': Vue.$trans(`北京金融`), //北京金融
            // 'cn-shanghai-fin': Vue.$trans(`上海金融`), //上海金融
            // 'cn-qingdao-1': Vue.$trans(`青岛1区（VPC）`), //青岛1区(VPC)
            // 'cn-north-1-gov': Vue.$trans(`华北1（政务）`), //华北1(政务)

            //测试环境机房
            "cn-qingyangtest-1": Vue.$trans(`庆阳1区（测试）`), //庆阳1区（测试）
            // "cn-qingdaodev-1": Vue.$trans(`自用（青岛2）`), //自用(青岛2) 原：青岛研发1区(VPC)
            // "cn-shanghai-3": Vue.$trans(`华东2（上海）`), //华东2(上海) 原：上海3区(VPC)
            // "cn-shanghai-7": Vue.$trans(`上海3区（Basic）`), //上海3区(Basic)

            //线上环境机房
            "cn-beijing-6": Vue.$trans(`华北1（北京）`), //华北1(北京) 原：北京6区(VPC)
            "cn-beijing-fin": Vue.$trans(`华北金融1（北京）`), //华北金融1(北京) 原：北京金融（万国)
            "cn-north-1-gov": Vue.$trans(`华北政务1（北京）`), //华北政务1(北京) 原：华北1(政务)
            "cn-shanghai-2": Vue.$trans(`华东1（上海）`), //华东1(上海) 原：上海2区(VPC)
            "cn-shanghai-fin": Vue.$trans(`华东金融1（上海）`), //华东金融1(上海) 原：上海金融（鹏博士)
            "cn-guangzhou-1": Vue.$trans(`华南1（广州）`), //华南1(广州) 原：广州1区(VPC)
            "cn-hongkong-2": Vue.$trans(`香港`), //香港 原：香港2区(VPC)
            "cn-taipei-1": Vue.$trans(`台北`), //台北 原：台北1区(VPC)
            "cn-qingdao-1": Vue.$trans(`自用（青岛）`), //自用(青岛) 原：青岛1区(VPC)
            "ap-singapore-1": Vue.$trans(`新加坡`), //新加坡 原：新加坡机房
            "eu-east-1": Vue.$trans(`俄罗斯（莫斯科）`), //俄罗斯(莫斯科) 原：俄罗斯1区(VPC)
            "cn-northwest-1": Vue.$trans(`西北1区（庆阳）`),
            "cn-northwest-2": Vue.$trans(`西北2区（自用）`),
            "cn-north-vip1": Vue.$trans(`华北专属1区（天津-小米）`),
            "cn-northwest-3": Vue.$trans('西北3区（宁夏）'),

            //主机控制台暂未启用
            "cn-central-1": Vue.$trans(`华中1（武汉）`), //华中1(武汉) 原：华中1
            "cn-southwest-1": Vue.$trans(`西南1（重庆）`), //西南1(重庆) 原：西南1
            "ap-Indonesia-1": Vue.$trans(`印度尼西亚（雅加达）`), //印度尼西亚(雅加达) 原：印尼1(VPC)

        }
        return map[key] || key;
    },
    areaMap(key) { //大区映射
        var map = {
            "cn": Vue.$trans(`国内`), //"国内",
            "ap": Vue.$trans(`亚太`), //'亚太',
            "eu": Vue.$trans(`欧洲`), //'欧洲'
        }
        return map[key] || key;
    },
    //跳转到帮助文档
    openHelpDoc: function (url, enUrl, zindex) {
        if (!url || !enUrl) {
            return;
        }
        __ksStorage__.docSet({
            indexUrl: '//docs.ksyun.com/documents/' + url,
            indexEnUrl: '//endocs.ksyun.com/documents/' + enUrl,
            zIndex: zindex ? zindex : 1000
        });
    },
    snapNameMap(key) {
        var map = {
            'active': Vue.$trans(`完成`),     //完成
            'restoring': Vue.$trans(`回滚中`),     //回滚中
            'saving': Vue.$trans(`创建中`),    //  创建中
            'unknown': Vue.$trans(`未知错误`),  //未知状态
            'error': Vue.$trans(`错误`),   //错误
            'queued': Vue.$trans(`排队中`), //排队中
            'deleted': Vue.$trans(`主机已删除`) //主机已删除
        };
        return map[key] || key;
    },

    seriesMap: {
        1: Vue.$trans(`系列1`),
        2: Vue.$trans(`系列2`),
        3: Vue.$trans(`系列3`),
        4: Vue.$trans(`系列4`)
    },

    //可用区映射
    azMap: {
        //可用区A 武清
        'cn-qingyangtest-1a': Vue.$trans(`可用区A`),
        'cn-beijing-6a': Vue.$trans(`可用区A`),
        'cn-shanghai-2a': Vue.$trans(`可用区A`),
        'cn-hongkong-2a': Vue.$trans(`可用区A`),
        // 'cn-shanghai-3a': Vue.$trans(`可用区A`),
        'ap-singapore-1a': Vue.$trans(`可用区A`),
        'cn-beijing-1-newa': Vue.$trans(`可用区A`),
        'cn-guangzhou-1a': Vue.$trans(`可用区A`),
        'eu-east-1a': Vue.$trans(`可用区A`),
        'cn-wuhan-1a': Vue.$trans(`可用区A`),
        'cn-taipei-1a': Vue.$trans(`可用区A`),
        'cn-beijing-fin-a': Vue.$trans(`可用区A`),
        'cn-shanghai-fin-a': Vue.$trans(`可用区A`),
        'cn-qingdao-1a': Vue.$trans(`可用区A`),
        'cn-north-1-gov-a': Vue.$trans(`可用区A`),
        'cn-north-vip1a': Vue.$trans(`可用区A`),

        //可用区B 中经
        'cn-qingyangtest-1b': Vue.$trans(`可用区B`),
        'cn-beijing-6b': Vue.$trans(`可用区B`),
        'cn-shanghai-2b': Vue.$trans(`可用区B`),
        // 'cn-shanghai-3b': Vue.$trans(`可用区B`),
        'ap-singapore-1b': Vue.$trans(`可用区B`),
        'cn-beijing-1-newb': Vue.$trans(`可用区B`),
        'cn-guangzhou-1b': Vue.$trans(`可用区B`),
        'eu-east-1b': Vue.$trans(`可用区B`),
        'cn-wuhan-1b': Vue.$trans(`可用区B`),

        //可用区C 万国
        'cn-qingyangtest-1c': Vue.$trans(`可用区C`),
        'cn-beijing-6c': Vue.$trans(`可用区C`),
        'cn-shanghai-2c': Vue.$trans(`可用区C`),
        // 'cn-shanghai-3c': Vue.$trans(`可用区C`),
        'ap-singapore-1c': Vue.$trans(`可用区C`),

        //可用区D 天津智慧港 常熟
        'cn-beijing-6d': Vue.$trans(`可用区D`),
        'cn-shanghai-2d': Vue.$trans(`可用区D`),

        //可用区E 天津逸仙园
        'cn-beijing-6e': Vue.$trans(`可用区E`),

        'cn-northwest-3a': Vue.$trans('可用区A'),
        // 以下两个暂时没有，先加上吧
        'cn-northwest-3b': Vue.$trans('可用区B'),
        'cn-northwest-3c': Vue.$trans('可用区C'),
    },

    productTypeMap: {
        40: Vue.$trans(`通用型N1`),//'通用型N1',
        41: Vue.$trans(`IO优化型I1`),//'IO优化型I1',
        137: Vue.$trans(`通用型N2`), //'通用型N2',
        151: Vue.$trans(`通用型N3`), //'通用型N2',
        42: Vue.$trans(`计算优化型C1`),//'计算优化型C1',
        138: Vue.$trans(`性能保障型X2`), //'性能保障型X2',
        45: Vue.$trans(`IO优化型I1（联网增强）`), //IO优化型I1（联网增强）
        46: Vue.$trans(`计算优化型C1（联网增强）`),  //计算优化型C1（联网增强）
        78: Vue.$trans(`IO优化型I2`), //'IO优化型I2',
        110: Vue.$trans(`IO优化型I3`), //'IO优化型I3',
        79: Vue.$trans(`IO优化型I2（联网增强）`), //IO优化型I2（联网增强）
        111: Vue.$trans(`计算优化型C3`),//'计算优化型C3',
        152: Vue.$trans(`标准型S3`), //'标准型S3',
        101: Vue.$trans(`GPU推理计算型（P3I）`),//'GPU推理计算型(P3I)',
        77: Vue.$trans(`GPU通用计算型（P3）`),//'GPU通用计算型(P3)',
        125: Vue.$trans(`GPU通用计算型（P4V）`),//'GPU通用计算型(P4V)',
        126: Vue.$trans(`GPU图形计算型（G1）`),//'GPU图形计算型(G1)',
        142: Vue.$trans(`GPU推理计算型（P3IN）`),//'GPU推理计算型(P3IN)'
        321: Vue.$trans(`GPU虚拟型（vGN5）`), //'GPU虚拟型(vGN5)',
        661: Vue.$trans(`GPU高效计算型（P5V）`), //'GPU高效计算型（P5V）',
        187: Vue.$trans(`标准网络型SN3`), //标准网络型SN3
        198: Vue.$trans(`标准型SA1`), //'标准型SA1',
        305: Vue.$trans(`ARM计算型AC1`), //'ARM计算型AC1'
        303: Vue.$trans(`基础型E1`), //'基础型E1',
        326: Vue.$trans(`GPU推理Ⅱ型（GN6I）`), //'推理Ⅱ型(GN6I)',
        353: Vue.$trans(`GPU通用计算型（P3L）`), //'GPU通用计算型(P3L)',
        347: Vue.$trans(`计算优化型C4`), //'计算优化型C4'，
        548: Vue.$trans(`计算优化型C5`), //'计算优化型C5'
        348: Vue.$trans(`标准型S4`), //'标准型S4'，
        652: Vue.$trans(`标准型A6`), //'标准型A6'，
        357: Vue.$trans(`IO优化型I4`), //'IO优化型I4',
        377: Vue.$trans(`GPU虚拟型（vGN6）`), //'GPU虚拟型(vGN6)',
        388: Vue.$trans(`ARM计算型AC2`), //'ARM计算型AC2'
        430: Vue.$trans(`大数据型D4`), //'大数据型D4'
        641: Vue.$trans(`大数据型D6`), //'大数据型D6'
        401: Vue.$trans(`ARM计算型FC1`), //'ARM计算型FC1'
        // 498: Vue.$trans(`标准IO优化型S4E`), //'标准IO优化型S4E'
        628: Vue.$trans(`极速云盘型X6E`), //极速云盘型X6E
        508: Vue.$trans(`性能保障型X5`), //'性能保障型X5'
        547: Vue.$trans(`性能保障型X6`), //'性能保障型X6'
        298: Vue.$trans(`标准型S1`), //'标准型S1'
        597: Vue.$trans(`GPU推理I型（GN5I）`), //'GPU推理I型(GN5I)'
        627: Vue.$trans(`性能保障型X6H`), //性能保障型X6H
        647: Vue.$trans(`内存型R6`),
        656: Vue.$trans(`星河云服务器`),
        651: Vue.$trans(`网络增强型X6N`),
        668: Vue.$trans(`IO优化型I6`),
        650: Vue.$trans(`性能增强型X6S`),
        690: Vue.$trans(`GPU通用计算型GN7I`),
        687: Vue.$trans(`性能保障型X7`),
        712: Vue.$trans(`计算优化型C7`),
        729: Vue.$trans(`性能保障型X8`),
        731: Vue.$trans(`专属型NI6`),
    },


    billTypeMap(key) { //计费类型
        var map = {
            // 1: '包年包月',
            // 5: '按日月结',
            // 2: '按小时',
            // 3: '按峰值月结',
            // 80: '按固定带宽',
            // 82: '按量付费'
            '1': Vue.$trans(`包年包月`), //'包年包月',
            '2': Vue.$trans(`按小时`), //'按小时',
            '3': Vue.$trans(`按量付费（月峰值）`), //'按峰值月结',
            '5': Vue.$trans(`按量付费（按日月结）`), //'按日月结',
            '80': Vue.$trans(`按固定带宽`), //按固定带宽
            '82': Vue.$trans(`按量付费`), //按量付费
            '83': Vue.$trans(`地域共享带宽`), //地域共享带宽
            '84': Vue.$trans(`按量付费（按小时月结）`), //按小时月结
            '81': Vue.$trans(`按使用流量`),//'按使用流量',
            '704': Vue.$trans(`按量付费（流量月结）`),//'按量月结',
            '2017': Vue.$trans(`试用`) ,//试用 前端自己定义的
            '87': Vue.$trans(`按量付费`), //'按小时实时结算'
            '86': Vue.$trans(`按量付费（流量）`), //'按日用量实时付费',
            '807': Vue.$trans(`增强型95付费`), //按月增强95峰值付费(月结)
            '808': Vue.$trans(`第5峰均值付费`), //'按月第5峰均值付费(月结)',
            '809': Vue.$trans(`按量付费（小时用量）`), //'按小时用量实时付费(小时结)',
            '810': Vue.$trans(`竞价型实例`)//'竞价型实例',
        }
        return map[key] || key;
    },

    dediceteTypeMap(key) { //专属云映射
        var map = {
            '96': Vue.$trans(`专属型`), //专属型,
            '143': Vue.$trans(`专属型2.0`), //专属型2.0,
            '517': Vue.$trans(`专属型3.0`), //专属型3.0,
            '603': Vue.$trans(`GPU专属型`), //GPU专属型,
            '642': Vue.$trans(`专属型6.0`), //专属型6.0,
        }
        return map[key] || key;
    },
    // 硬盘状态列表
    diskNameMap: {
        'attached': Vue.$trans(`已挂载`),  //已挂载
        'saving': Vue.$trans(`快照中`),    //快照中
        'restoring': Vue.$trans(`回滚中`), //回滚中

        'system': Vue.$trans(`系统盘`),    //系统盘
        'data': Vue.$trans(`数据盘`),  //数据盘
        'SSD': Vue.$trans(`本地SSD`),    //本地SSD盘
        'SATA': Vue.$trans(`本地SATA`),  //本地SATA盘
        // 老版字段
        'c1': Vue.$trans(`本地SSD`),     //本地SSD盘
        'k1': Vue.$trans(`本地SATA`),    //本地SATA盘
        'c1_en': Vue.$trans(`本地SSD`),     //本地SSD盘
        'root': Vue.$trans(`系统盘`),      //系统盘
        'ephemeral': Vue.$trans(`数据盘`),      //数据盘
        '':''
    },
}
